
export const maplocation = {
    address: 'Lynnridge Laundry #1 1603 62 Ave SE',
    lat: 50.997511606641766,
    lng: -114.01970769281202,
  }

  export default maplocation;